// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DeleteWarrantyTicketMutationVariables = Types.Exact<{
  input: Types.DeleteWarrantyTicketInput;
}>;


export type DeleteWarrantyTicketMutation = { __typename?: 'Mutation', deleteWarrantyTicket: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const DeleteWarrantyTicketDocument = gql`
    mutation DeleteWarrantyTicket($input: DeleteWarrantyTicketInput!) {
  deleteWarrantyTicket(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteWarrantyTicketMutationFn = Apollo.MutationFunction<DeleteWarrantyTicketMutation, DeleteWarrantyTicketMutationVariables>;

/**
 * __useDeleteWarrantyTicketMutation__
 *
 * To run a mutation, you first call `useDeleteWarrantyTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarrantyTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarrantyTicketMutation, { data, loading, error }] = useDeleteWarrantyTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWarrantyTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWarrantyTicketMutation, DeleteWarrantyTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWarrantyTicketMutation, DeleteWarrantyTicketMutationVariables>(DeleteWarrantyTicketDocument, options);
      }
export type DeleteWarrantyTicketMutationHookResult = ReturnType<typeof useDeleteWarrantyTicketMutation>;
export type DeleteWarrantyTicketMutationResult = Apollo.MutationResult<DeleteWarrantyTicketMutation>;
export type DeleteWarrantyTicketMutationOptions = Apollo.BaseMutationOptions<DeleteWarrantyTicketMutation, DeleteWarrantyTicketMutationVariables>;